// extracted by mini-css-extract-plugin
export default {"brandPromo":"wI-z","carousel":"xI-z"};